(() => {
  if (window.__dpsSuccessfulAddTracking) return;
  window.__dpsSuccessfulAddTracking = true;

  const processed = new WeakSet();
  const allowed = (method) => {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.[method] !== 'function') return true;
    try {
      return privacy[method]() === true;
    } catch {
      return false;
    }
  };

  const ecommerce = (detail) => {
    const response = detail.product;
    const request = detail.dps;
    if (!response || response.status || !Array.isArray(request?.items)) return null;
    if (!/^[A-Z]{3}$/.test(request.currency || '')) return null;

    const quantities = new Map();
    for (const item of request.items) {
      if (!item || typeof item !== 'object') return null;
      const id = String(item.id || '');
      const quantity = Number(item.quantity);
      if (!/^\d+$/.test(id) || !Number.isSafeInteger(quantity) || quantity < 0) return null;
      const total = (quantities.get(id) || 0) + quantity;
      if (!Number.isSafeInteger(total)) return null;
      if (quantity > 0) quantities.set(id, total);
    }
    if (!quantities.size) return null;

    const lines = Array.isArray(response.items) ? response.items : [response];
    const items = [];
    let value = 0;
    for (const [id, quantity] of quantities) {
      const matching = lines.filter((line) => line && String(line.variant_id || line.id || '') === id);
      if (matching.length !== 1) return null;
      const line = matching[0];
      const rawPrice = line.final_price ?? line.price;
      if (typeof rawPrice !== 'number' || !Number.isFinite(rawPrice) || rawPrice < 0) return null;
      if (!Number.isFinite(Number(line.quantity)) || Number(line.quantity) < quantity) return null;
      value += rawPrice * quantity;
      items.push({
        item_id: id,
        item_name: String(line.product_title || line.title || ''),
        item_brand: String(line.vendor || ''),
        item_category: String(line.product_type || ''),
        item_variant: String(line.variant_title || ''),
        price: rawPrice / 100,
        quantity
      });
    }
    if (!Number.isFinite(value)) return null;
    return { currency: request.currency, value: Math.round(value) / 100, items };
  };

  document.addEventListener('ajaxProduct:added', (event) => {
    const detail = event.detail;
    if (!detail || typeof detail !== 'object' || processed.has(detail)) return;
    const payload = ecommerce(detail);
    if (!payload) return;
    processed.add(detail);

    if (allowed('analyticsProcessingAllowed') && typeof window.dataLayer?.push === 'function') {
      try {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({ event: 'add_to_cart', ecommerce: payload });
      } catch {}
    }

    if (allowed('marketingAllowed') && allowed('saleOfDataAllowed') && typeof window.fbq === 'function') {
      try {
        window.fbq('track', 'AddToCart', {
          content_ids: payload.items.map((item) => item.item_id),
          content_type: 'product',
          contents: payload.items.map((item) => ({ id: item.item_id, quantity: item.quantity, item_price: item.price })),
          value: payload.value,
          currency: payload.currency,
          num_items: payload.items.reduce((total, item) => total + item.quantity, 0)
        });
      } catch {}
    }
  });
})();
